module.exports = __webpack_public_path__ + "static/media/Spooky Boy.48ccd972.jpg";